import React from 'react';

export default function ColorBox({ props }) {
	return (
		<div
			className='color-box'
			style={{
				background: props.background,
			}}
		>
			<div className='colors'>
				<div className='colour_small' style={{ background: props.secondary }}></div>
				<div
					className='colour_large'
					style={{ background: props.primaryColor }}
				></div>
			</div>
			<span className='text-color' style={{ color: props.textColor }}>
				Webbler
			</span>
		</div>
	);
}
